'use client';

import { FC, useCallback, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useTelegramMiniApp } from 'app/_context/TelegramContext';
import { BackButton } from 'app/_components/BackButton';

type IGoBackBtn = {
  onclick: () => void
};

export const GoBackBtn: FC<IGoBackBtn> = (props: IGoBackBtn) => {
  const router = useRouter();
  const { isEnabledTWA, showBackButtonTWA, hideBackButtonTWA } = useTelegramMiniApp();

  const backHandler = useCallback(() => {
    router.back();
    props.onclick();
  }, [props, router]);

  useEffect(() => {
    if (!isEnabledTWA) return;
    showBackButtonTWA(backHandler);
    return () => {
      hideBackButtonTWA(backHandler);
    };
  }, [backHandler, hideBackButtonTWA, isEnabledTWA, showBackButtonTWA]);

  return (
    <>
      {!isEnabledTWA && (
        <div className='absolute right-full -translate-x-[80px] md:hidden'>
          <BackButton onclick={props.onclick} />
        </div>
      )}
    </>
  );
};
